import { CustomForm, CustomFormArray, CustomFormGroup } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { ProvValidator } from "@tilby/tilby-ui-lib/utilities";
import { ItemsForm } from "src/app/features/items/models/items-form.model";
import { ItemsBomComponents } from "tilby-models";

export type ItemStockFormGroups = CustomFormGroup<ItemStockFormGroupsFields>;

export type ItemStockFormGroupsFields = ItemsFormWithCustomBomComponents & ItemStockFormGroupsExtraFields;

export type ItemStockFormGroupsExtraFields = Partial<CustomForm<ItemStockFormGroupsFieldsFe>>;

interface ItemStockFormGroupsFieldsFe {
    is_stock_active?: boolean;
}

export type ItemsFormWithCustomBomComponents = Omit<ItemsForm, 'bom_components'> & {
    bom_components?: CustomFormArray<CustomFormGroup<BomComponentsWithSubBomComponents>>;
};

export type BomComponentsWithSubBomComponents = Omit<ItemBomComponentsFormArray, 'bom_components'> & {
    bom_components?: CustomFormArray<CustomFormGroup<ItemBomComponentsFormArray>>;
};

export type ItemBomComponentsFormArray = Partial<CustomForm<ItemBomComponentsFields>>;
export type ItemBomComponentsFields = ItemsBomComponents & ItemsBomComponentsFieldsFe;

// export type ItemsBomComponentsExtended = ItemsBomComponents & {
//     bom_components?: Partial<ItemBomComponentsFields>[]
// }

interface ItemsBomComponentsFieldsFe {
    index?: number;
    expanded?: boolean;
    type?: string;
    cost?: number;
    unit?: string;
}

export interface ItemStockValidators extends ProvValidator {
    minQntAlert: number;
    minBomComponentQnt: number;
}

export const STOCK_KEY_FE = [
    'is_stock_active',
    'index',
    'expanded',
    'type',
]